import _ from 'lodash';

import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    accessToken: null,
    userName: null,
    roles: null,
    permissions: null,
    lastState: null,
    lastScope: null,
    prevRoute: null
};

const authenticationReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.AUTHENTICATION_START: {
            return updateState(state, {
                accessToken: null,
                lastState: constants.STATE_AUTHENTICATING,
                roles: null,
                permissions: null,
                prevRoute: null
            });
        }
        case actionTypes.AUTHENTICATION_SUCCESS: {
            let newState = {
                userName: action.userName,
                accessToken: action.accessToken,
                lastState: constants.STATE_SUCCESS
            };

            if (action.prevRoute) {
                newState['prevRoute'] = action.prevRoute;
            }

            newState.roles = action.roles;
            
            if (!_.isEmpty(action.permissions)) {
                newState.permissions = JSON.parse(action.permissions);
            }
            
            return updateState(state, newState);
        }
        case actionTypes.AUTHENTICATION_FAIL: {
            return updateState(state, {
                userName: null,
                acccessToken: null,
                roles: null,
                permissions: null,
                lastState: constants.STATE_FAIL,
                prevRoute: null
            });
        }
        case actionTypes.AUTHENTICATION_CLEAR:
        case actionTypes.AUTHENTICATION_LOGOUT: {
            return updateState(state, {
                userName: null,
                accessToken: null,
                lastState: null,
                roles: null,
                permissions: null,
                prevRoute: null
            });
        }
        default: {
            return state;
        }
    }
};

export default authenticationReducer;